import { render, staticRenderFns } from "./DistressalertsFormHeader.vue?vue&type=template&id=1726932c"
import script from "./DistressalertsFormHeader.vue?vue&type=script&lang=js"
export * from "./DistressalertsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports